import { Link } from "react-router";
import { _ } from "i18n";
import { DiscoverClubTeamSide } from "../../../discover/gamesTable/v2/constants";
import type { ColumnConfig } from "../../types";
import {
	DISCOVER_GAMES_TEAM_SIDE_ROW_FIELDS,
	DiscoverGamesColumnField,
	DiscoverGamesUiColumnKey,
	DISCOVER_GAMES_COL_WIDTH_AWAY,
	DISCOVER_GAMES_COL_WIDTH_HOME,
} from "../constants";
import type { GameRow } from "../types";

function gameSideCell(row: GameRow, side: DiscoverClubTeamSide) {
	const fields = DISCOVER_GAMES_TEAM_SIDE_ROW_FIELDS[side];
	const clubId = row[fields.clubId] as number | undefined;
	const clubName = row[fields.clubName] as string | undefined;
	const fallbackClubName = row[fields.fallbackClubName] as string | undefined;
	const teamId = row[fields.teamId] as number | undefined;
	const teamName = row[fields.teamName] as string | undefined;
	const fallbackTeamName = row[fields.fallbackTeamName] as string | undefined;

	return (
		<div className="thinCell">
			{clubId != null && clubName ? (
				<Link to={`/discover/club/${clubId}`}>
					<strong>
						{clubName} ({clubId})
					</strong>
				</Link>
			) : fallbackClubName ? (
				<strong>
					<em>{fallbackClubName}</em>
				</strong>
			) : (
				"-"
			)}
			<br />
			{teamId != null && teamName ? (
				<Link to={`/discover/team/${teamId}`}>
					{teamName} ({teamId})
				</Link>
			) : fallbackTeamName ? (
				<em>{fallbackTeamName}</em>
			) : (
				"-"
			)}
		</div>
	);
}

export function homeColumn(): ColumnConfig<GameRow> {
	const side = DiscoverClubTeamSide.Home;
	const sideFields = DISCOVER_GAMES_TEAM_SIDE_ROW_FIELDS[side];
	return {
		key: DiscoverGamesUiColumnKey.Home,
		label: _("discover.gamesTable.column.home"),
		sortable: true,
		sortField: DiscoverGamesColumnField.HomeClubName,
		minWidth: DISCOVER_GAMES_COL_WIDTH_HOME.min,
		maxWidth: DISCOVER_GAMES_COL_WIDTH_HOME.max,
		cell: (_, row) => gameSideCell(row, side),
		group: _("discover.gamesTable.group.teams"),
		defaultVisible: true,
		requiredFields: Object.values(sideFields),
	};
}

export function awayColumn(): ColumnConfig<GameRow> {
	const side = DiscoverClubTeamSide.Away;
	const sideFields = DISCOVER_GAMES_TEAM_SIDE_ROW_FIELDS[side];
	return {
		key: DiscoverGamesUiColumnKey.Away,
		label: _("discover.gamesTable.column.away"),
		sortable: true,
		sortField: DiscoverGamesColumnField.AwayClubName,
		minWidth: DISCOVER_GAMES_COL_WIDTH_AWAY.min,
		maxWidth: DISCOVER_GAMES_COL_WIDTH_AWAY.max,
		cell: (_, row) => gameSideCell(row, side),
		group: _("discover.gamesTable.group.teams"),
		defaultVisible: true,
		requiredFields: Object.values(sideFields),
	};
}
